import { render, staticRenderFns } from "./UnpaidTasksList.vue?vue&type=template&id=35454ab9&scoped=true"
import script from "./UnpaidTasksList.vue?vue&type=script&lang=js"
export * from "./UnpaidTasksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35454ab9",
  null
  
)

export default component.exports